export enum WebPhoneAnalyticsEvents {
  StartCallFromModal = 'new_from_modal',
  StartCallFromPage = 'new_from_page',
  NewCallModalOpened = 'new_call_modal_opened',
  ClickToCallWebPhone = 'c2c_web',
  ClickToCallDeskPhone = 'c2c_desk',
  // Reliability signals (observability RFC): click-to-dial success rate —
  // % of originate requests accepted by the API.
  ClickToDialSucceeded = 'c2c_originate_succeeded',
  ClickToDialFailed = 'c2c_originate_failed',
  OutboundNumberSelection = 'outbound_num_selected',
  OutboundSearchInputExtensionClicked = 'outbnd_srch_inpt_clkd',
  InviteAnswered = 'inv_answered',
  InviteRejectedClick = 'inv_rej_click',
  InviteRejectedDND = 'inv_rej_dnd',
  InviteRejectedBusy = 'inv_rej_busy',
  RestartSipClientErrorClick = 'restart_sipc_err_click',
  RestartSipClientInitClick = 'restart_sipc_init_click',
  RestartSipClientStatusPanelClick = 'restart_sipc_status_click',
  RecentlyDialedStartCallClicked = 'rcnt_dialed_start_call_clkd',
  SearchStartCallClicked = 'srch_start_call_clkd',
  SearchStartCallWithOptionsClicked = 'srch_call_primary_clkd',
  SearchDropdownItemClicked = 'srch_call_dropdwn_clkd',
  ShowDialpadClicked = 'show_dialpad_clkd',
  DndOff = 'dnd_off',
  DndOn = 'dnd_on',
  WarmTransfer = 'warm_xfer',
  ColdTransfer = 'cold_xfer',
  ExtSwitched = 'ext_switched',
  ExtSelected = 'ext_selected',
  Deactivated = 'deactivated',
  NetworkConnected = 'network_connected',
  NetworkDisconnected = 'network_disconnected',
  ModalAnswerClicked = 'modal_answer',
  ModalHoldAndAcceptClicked = 'modal_hold_accept',
  ModalEndAndAcceptClicked = 'modal_end_accept',
  ModalParkAndAcceptClicked = 'modal_park_accept',
  PopupAnswerClicked = 'popup_answer',
  PopupHoldAndAcceptClicked = 'popup_hold_accept',
  PopupEndAndAcceptClicked = 'popup_end_accept',
  PopupParkAndAcceptClicked = 'popup_park_accept',
  PopupPatientDeepLinkClicked = 'popup_patient_deeplink',
  OrphanedCallCleanup = 'orphaned_call_cleanup',
  // Diagnostic: a React #185 "Maximum update depth exceeded" fired on /web-phone.
  // Payload is a PHI-safe render-state snapshot to pinpoint the loop's trigger.
  MaxUpdateDepthDetected = 'max_update_depth_detected',
}
